var Album;

Album = function(self, options) {
  Modelize(self, {
    api: api.galleries.albums,
    belongs_to: self.gallery_id,
    has_many: ['asset'],
    has_one: ['asset'],
    editable: ['name']
  });
  Sortable(self);
  Selectable(self);
  self.set_cover = (function(_this) {
    return function(asset, callback) {
      return self.update({
        asset_id: asset.id
      }, callback);
    };
  })(this);
  return self;
};

if (api.galleries == null) {
  api.add('galleries');
}

api.add('albums');

api.galleries.add('albums');

api.galleries.albums.add('assets');

Collection(Album, api.galleries.albums);

//# sourceMappingURL=album.js.map
